import React, { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { UserCategory } from '~/common/constants';

const StyledLabel = styled.span`
  display: inline-block;
  width: max-content;
  line-height: 1.8rem;
  background: #fff;
  padding: 0 4px;
  text-align: center;
  border: 1px solid #022b4d;
  color: #022b4d;
  font-size: 1em;
  margin-right: 5px;
`;

type Props = {
  userType: UserCategory;
};

const UserCategoryLabel: React.FC<Props> = ({ userType }) => {
  const { t } = useTranslation();
  return (
    <StyledLabel data-testid="uiElements-UserCategoryLabel">
      {t(`user.category.${userType}`)}
    </StyledLabel>
  );
};

export default memo(UserCategoryLabel);
